import { defineStore } from 'pinia'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import relativeTime from 'dayjs/plugin/relativeTime'
import { apiHttp, VITE_API_URL_PROTOCOLS } from '../api/axiosApi'
import { notificationsList, notificationUpdate } from '../api/config/apiRoute'

dayjs.extend(relativeTime)

export const useNotificationStore = defineStore('notifications', {
  state: () => ({
    notifications: []
  }),
  actions: {
    async fetchUnreadNotifications() {
      const response = await apiHttp('GET', `${VITE_API_URL_PROTOCOLS}${notificationsList}`)
      if (response && response.data) {
        const list = Array.isArray(response.data) ? response.data : response.data.data || []
        this.notifications = list.map((n) => ({
          ...n,
          id: n.uuid || n.notification_uuid || n.id || n._id,
          time: n.created_at
            ? dayjs(n.created_at).locale('es').fromNow()
            : dayjs().locale('es').fromNow(),
          title: n.title || n.message || 'Nueva Notificación',
          receivedAt: n.created_at ? new Date(n.created_at) : new Date()
        }))
      }
    },
    async markAsRead(id) {
      // Optimistic remove
      this.removeNotification(id)
      try {
        await apiHttp('PUT', `${VITE_API_URL_PROTOCOLS}${notificationUpdate}/${id}/read`)
      } catch (error) {
        console.error('Error marking notification as read:', error)
      }
    },
    addNotification(data, locale = 'es') {
      const newNotification = {
        ...data,
        id: data.uuid || data.notification_uuid || data.id || data._id || Date.now(),
        title: data.message || data.title || 'Nueva Notificación',
        time: dayjs().locale(locale).fromNow(),
        receivedAt: new Date()
      }
      this.notifications.unshift(newNotification)
    },
    removeNotification(id) {
      this.notifications = this.notifications.filter((n) => n.id !== id)
    },
    clearAll() {
      this.notifications = []
    }
  },
  getters: {
    unreadCount: (state) => state.notifications.length
  }
})
